import React, { Fragment } from 'react';
import moment from 'moment';
import Link from 'react-router-dom/Link';
import AssessmentIcon from 'material-ui-icons/Assessment';
import EditIcon from 'material-ui-icons/Edit';


export default ({row, participantMode}) => (
	<div style={{margin:'15px 0px', padding:'0 10px', borderLeft:`solid 3px ${!participantMode && window.app.statusMap[row.status].color}`}}>
		<div style={{display:'flex', flexDirection:'row'}}>
			<div style={{flex:1, fontSize:'18px'}}>
				{ !participantMode &&
					<Fragment>
						{row.name}
						<Link title="Edit experiment" to={`/edit-experiment/${row.experimentId}`}>
							<EditIcon style={{marginLeft:'10px', position:'relative', top:'5px'}} />
						</Link>
						<Link title="Results" to={`/results/${row.experimentId}`}>
							<AssessmentIcon style={{marginLeft:'10px', position:'relative', top:'5px'}} />
						</Link>
					</Fragment>
				}

				{ !!participantMode &&
					<Link to={`/experiments/${row.experimentId}`}>{row.name}</Link>
				}
				<div style={{fontSize:'12px'}}>${row.incentive} &nbsp;&nbsp;&nbsp; ~{row.time} minutes</div>
				{
					!participantMode && 
					<div style={{fontSize:'12px'}}>
						Status: {window.app.statusMap[row.status].label} &nbsp;&nbsp;&nbsp; 
						Participants: {row.numClaims} &nbsp;&nbsp;&nbsp; Completed: {+row.numResponses || '0'} of {row.participantCap || 0}<br />
						<a onClick={ ()=> {window.app.duplicateExperiment({experimentId:row.experimentId})} }>Duplicate</a>
					</div>
				}
			</div>
			<div style={{textAlign:'right', paddingTop:'6px', fontSize:'12px', color:'#a5a5a5'}}>
				{row.start ? moment(row.start).format('ll') : ''}
			</div>
		</div>
		<div style={{fontSize:'14px', padding:'10px 0'}}>{row.description}</div>
	</div>
)


// WEBPACK FOOTER //
// ./src/components/ExperimentListItem.js